import React from 'react';
import { getColorSwatchSurfaceProps } from '@loomstateorg/shared-frontend/helpers/facetColorSwatch';

export interface ColorFacetSwatchProps {
  colorKey: string;
  hexColor?: string;
  isSelected?: boolean;
  sizeClassName?: string;
  slotClassName?: string;
  className?: string;
}

const SLOT_BY_INNER_SIZE: Record<string, string> = {
  'size-16': 'size-24',
  'size-20': 'size-28',
};

const RING_CLASS = 'p-[2px]';
const GAP_CLASS = 'p-[2px]';

const ColorFacetSwatch = ({
  colorKey,
  hexColor,
  isSelected = false,
  sizeClassName = 'size-20',
  slotClassName,
  className = '',
}: ColorFacetSwatchProps): JSX.Element => {
  const { className: swatchClassName, style: swatchStyle } = getColorSwatchSurfaceProps(colorKey, hexColor);
  const slotSizeClassName = slotClassName ?? SLOT_BY_INNER_SIZE[sizeClassName] ?? 'size-28';

  return (
    <span className={`inline-flex shrink-0 items-center justify-center ${slotSizeClassName} ${className}`}>
      {isSelected ? (
        <span className={`inline-flex rounded-full ${RING_CLASS} ${swatchClassName}`} style={swatchStyle}>
          <span className={`inline-flex rounded-full bg-white ${GAP_CLASS}`}>
            <span className={`${sizeClassName} rounded-full ${swatchClassName}`} style={swatchStyle} />
          </span>
        </span>
      ) : (
        <span
          className={`${slotSizeClassName} rounded-full border border-neutral-400 ${swatchClassName}`}
          style={swatchStyle}
        />
      )}
    </span>
  );
};

export default ColorFacetSwatch;
